import { Box, Typography } from '@mui/material';

import { COLORS } from '~/styles/colors';
import { mainPreviewContainerStyles } from '~/styles/common';

type TextMockupProps = {
  message?: string;
};

export const TextMockup = ({ message = 'Message text...' }: TextMockupProps) => {
  return (
    <Box sx={{ ...mainPreviewContainerStyles, alignItems: 'flex-start' }}>
      <Box sx={{ padding: 1.2, paddingTop: 5, width: '100%' }}>
        <Typography sx={{ fontSize: 16, wordBreak: 'break-word', color: COLORS.black }}>{message}</Typography>
      </Box>
    </Box>
  );
};
